import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { MessageSquare } from 'lucide-react';

const AccountingCommunication = () => {
  return (
    <div className="space-y-6" data-testid="accounting-communication">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">İletişim</h1>
          <p className="text-gray-500">Muhasebe iletişim ve bildirimler</p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-indigo-600" />
            Mesajlar
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-12 text-gray-500">
            <MessageSquare className="h-12 w-12 mb-4 text-gray-300" />
            <p>İçerik yakında eklenecek</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccountingCommunication;
